import { createTrackingUtils } from "../index";
import { useEffect } from "react";
import useProfiler from "../../../hooks/useProfiler";

const utils = createTrackingUtils({
  name: "flights_web_pax_before_flex_ticket",
  stages: {
    main: 1,
    direct: 2,
    meta: 3,
    solo: 4,
    nonSolo: 5,
    us: 6
  },
  goals: {},
  defaultStage: 1
});

const useTrackStages = (isEligible?: boolean) => {
  const { isDirect, isSolo, isAmerican } = useProfiler();
  const { stages } = utils;

  useEffect(() => {
    if (!isEligible) {
      return;
    }

    isDirect() ? stages.direct() : stages.meta();
    isSolo() ? stages.solo() : stages.nonSolo();
    isAmerican() && stages.us();
  }, [isAmerican, isDirect, isEligible, isSolo, stages]);
};

export default { ...utils, useTrackStages };
